import { render } from "./BillGeneratedModal.vue?vue&type=template&id=4336d51d&scoped=true"
import script from "./BillGeneratedModal.vue?vue&type=script&lang=js"
export * from "./BillGeneratedModal.vue?vue&type=script&lang=js"

import "./BillGeneratedModal.vue?vue&type=style&index=0&id=4336d51d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4336d51d"]])

export default __exports__